import React, { forwardRef } from 'react'
import { InputProps as ChakraInputProps } from '@chakra-ui/core'

import { PseudoBox } from '../PseudoBox'
import { useInputStyle } from '../../hooks/useInputStyle'
import { useFormControl } from '../../hooks/useFormControl'

export interface TextAreaInputProps extends ChakraInputProps {
  onChangeValue?: (value: string) => void
  rows?: number
}

export const TextAreaInput = forwardRef((props: TextAreaInputProps, ref) => {
  const {
    size,
    variant,
    'aria-label': ariaLabel,
    'aria-describedby': ariaDescribedby,
    isReadOnly,
    isFullWidth,
    isDisabled,
    isInvalid,
    isRequired,
    focusBorderColor,
    errorBorderColor,
    onChange,
    onChangeValue,
    ...restProps
  } = props

  const inputStyleProps = useInputStyle(props)
  const formControl = useFormControl(props)

  const handleChange = event => {
    onChange && onChange(event)
    onChangeValue && onChangeValue(event.target.value)
  }

  inputStyleProps.minHeight = inputStyleProps.height
  inputStyleProps.height = null
  inputStyleProps.py = '0.5rem'
  inputStyleProps.transition = `${inputStyleProps.transition || ''} height 0s` // Fix resize

  return (
    <PseudoBox
      ref={ref}
      as="textarea"
      readOnly={formControl.isReadOnly}
      aria-readonly={isReadOnly}
      disabled={formControl.isDisabled}
      aria-label={ariaLabel}
      aria-invalid={formControl.isInvalid}
      required={formControl.isRequired}
      aria-required={formControl.isRequired}
      aria-disabled={formControl.isDisabled}
      aria-describedby={ariaDescribedby}
      onChange={handleChange}
      {...inputStyleProps}
      {...restProps}
    />
  )
})

TextAreaInput.displayName = 'TextAreaInput'

TextAreaInput.defaultProps = {
  size: 'md',
  variant: 'outline',
  isFullWidth: true,
  focusBorderColor: 'green.400',
  errorBorderColor: 'red.500',
}

export default TextAreaInput
